module.exports = __webpack_public_path__ + "img/logo-bigpicture-storybook.74a0b4ff.svg";